const RAW_BASE_URL = process.env.REACT_APP_BASE_URL;
const API_KEY = process.env.REACT_APP_AUDIO_API_KEY ?? "";

export type ArticleMeta = {
  articleId: number;
  title: string;
  summary: string;
  source: string;
};
function mapLanguageForAudioApi(lang: string): string {
  if (lang === "en") return "eng";
  return "pl";
}
export async function fetchLatestArticleMeta(language: string = "pl"): Promise<ArticleMeta> {
  const apiLang = mapLanguageForAudioApi(language);
  const url = `${RAW_BASE_URL}/cc/mainpage_top1?language=${apiLang}`;

  const res = await fetch(url, {
    method: "GET",
    headers: {
      accept: "application/json",
    },
  });

  if (!res.ok) {
    throw new Error(`Audio meta API error: ${res.status} ${res.statusText}`);
  }

  const data = await res.json();

  const items =
    data.processed_articles ??
    data.items ??
    data.data?.items ??
    data.results ??
    data.data ??
    data.articles ??
    [];

  const first =
    Array.isArray(items) && items.length > 0 ? items[0] : data.item ?? data;

  const articleId: number =
    first.article_id ??
    first.articleId ??
    first.id ??
    (() => {
      throw new Error("Brak article_id w odpowiedzi API");
    })();

  const summary: string =
    first.summary ??
    first.article_summary ??
    first.original_article?.summary ??
    "";

  const title: string =
    first.clickbait ??
    first.original_article?.clickbait ??
    first.original_article?.title ??
    first.title ??
    "Bez tytułu";

  const source: string =
    first.original_article?.source ??
    first.source ??
    "nieznane źródło";

  return {
    articleId,
    title,
    summary,
    source,
  };
}

export async function fetchArticleAudioBlob(
  articleId: number,
  language: string = "pl"
): Promise<Blob> {
  const apiLang = mapLanguageForAudioApi(language);
  const url = `${RAW_BASE_URL}/cc/mainpage_top1_audio?language=${apiLang}`;

  const res = await fetch(url, {
    method: "GET",
    headers: {
      accept: "audio/mpeg",
    },
  });

  if (!res.ok) {
    throw new Error(`Audio file API error: ${res.status} ${res.statusText}`);
  }

  return await res.blob();
}
